import { CSSProperties } from "react";
import { styx, clsx } from "modules/Utils";

// NOTE: V2 ICONS
import AddCircleIcon from 'assets/v2/icons/AddCircleIcon';
import AnalyticsIcon from 'assets/v2/icons/AnalyticsIcon';
import ArrowLeftIcon from 'assets/v2/icons/ArrowLeftIcon';
import ArrowRightIcon from 'assets/v2/icons/ArrowRightIcon';
import ArrowDownIcon from 'assets/v2/icons/ArrowDownIcon';
import ArrowUpIcon from 'assets/v2/icons/ArrowUpIcon';
import ArrowUpRightIcon from 'assets/v2/icons/ArrowUpRightIcon';
import AudiencesIcon from 'assets/v2/icons/AudiencesIcon';
import BillingIcon from 'assets/v2/icons/BillingIcon';
import BookIcon from 'assets/v2/icons/BookIcon';
import BoostIcon from 'assets/v2/icons/BoostIcon';
import BulletListIcon from 'assets/v2/icons/BulletListIcon';
import CalendarIcon from 'assets/v2/icons/CalendarIcon';
import ChartIcon from 'assets/v2/icons/ChartIcon';
import CheckIcon from 'assets/v2/icons/CheckIcon';
import ChevronLeftIcon from 'assets/v2/icons/ChevronLeftIcon';
import ChevronRightIcon from 'assets/v2/icons/ChevronRightIcon';
import ChevronUpIcon from 'assets/v2/icons/ChevronUpIcon';
import ChevronDownIcon from 'assets/v2/icons/ChevronDownIcon';
import ClickIcon from 'assets/v2/icons/ClickIcon';
import ClockIcon from 'assets/v2/icons/ClockIcon';
import CloseIcon from 'assets/v2/icons/CloseIcon';
import CloseCircleIcon from 'assets/v2/icons/CloseCircleIcon';
import CollapseDrawerIcon from 'assets/v2/icons/CollapseDrawerIcon';
import CommentsIcon from 'assets/v2/icons/CommentsIcon';
import ComputerIcon from 'assets/v2/icons/ComputerIcon';
import ContextualMenuIcon from 'assets/v2/icons/ContextualMenuIcon';
import CopyIcon from 'assets/v2/icons/CopyIcon';
import CrownIcon from 'assets/v2/icons/CrownIcon';
import DashboardIcon from 'assets/v2/icons/DashboardIcon';
import DollarSignIcon from 'assets/v2/icons/DollarSignIcon';
import DownloadIcon from 'assets/v2/icons/DownloadIcon';
import DownloadCloudIcon from 'assets/v2/icons/DownloadCloudIcon';
import DragIcon from 'assets/v2/icons/DragIcon';
import DuplicateIcon from 'assets/v2/icons/DuplicateIcon';
import EditIcon from 'assets/v2/icons/EditIcon';
import ExpandIcon from 'assets/v2/icons/ExpandIcon';
import ExpandDrawerIcon from 'assets/v2/icons/ExpandDrawerIcon';
import ExternalLinkIcon from 'assets/v2/icons/ExternalLinkIcon';
import FacebookPixelIcon from 'assets/v2/icons/FacebookPixelIcon';
import FileIcon from 'assets/v2/icons/FileIcon';
import GearIcon from 'assets/v2/icons/GearIcon';
import GemIcon from "assets/v2/icons/GemIcon";
import GiftIcon from 'assets/v2/icons/GiftIcon';
import GlobeIcon from 'assets/v2/icons/GlobeIcon';
import HeadphonesIcon from 'assets/v2/icons/HeadphonesIcon';
import HeartIcon from 'assets/v2/icons/HeartIcon';
import HeartRoundIcon from 'assets/v2/icons/HeartRoundIcon';
import HomeIcon from 'assets/v2/icons/HomeIcon';
import ImageIcon from 'assets/v2/icons/ImageIcon';
import InfoIcon from 'assets/v2/icons/InfoIcon';
import LearnIcon from 'assets/v2/icons/LearnIcon';
import LeaveIcon from 'assets/v2/icons/LeaveIcon';
import LighteningIcon from 'assets/v2/icons/LighteningIcon';
import LikeIcon from 'assets/v2/icons/LikeIcon';
import LimitIcon from 'assets/v2/icons/LimitIcon';
import LinkIcon from 'assets/v2/icons/LinkIcon';
import Link2Icon from 'assets/v2/icons/Link2Icon';
import LoadingIcon from 'assets/v2/icons/LoadingIcon';
import MailIcon from 'assets/v2/icons/MailIcon';
import MailAtSymbolIcon from 'assets/v2/icons/MailAtSymbolIcon';
import MapPinIcon from 'assets/v2/icons/MapPinIcon';
import MarketingIcon from 'assets/v2/icons/MarketingIcon';
import MenuIcon from 'assets/v2/icons/MenuIcon';
import MessageIcon from 'assets/v2/icons/MessageIcon';
import MobileIcon from 'assets/v2/icons/MobileIcon';
import MoneyIcon from 'assets/v2/icons/MoneyIcon';
import MusicIcon from 'assets/v2/icons/MusicIcon';
import PauseIcon from 'assets/v2/icons/PauseIcon';
import PersonCheckIcon from 'assets/v2/icons/PersonCheckIcon';
import PieChartIcon from 'assets/v2/icons/PieChartIcon';
import PlayIcon from 'assets/v2/icons/PlayIcon';
import PlusIcon from 'assets/v2/icons/PlusIcon';
import QrcodeIcon from 'assets/v2/icons/QrcodeIcon';
import QuestionMarkIcon from 'assets/v2/icons/QuestionMarkIcon';
import ReloadIcon from 'assets/v2/icons/ReloadIcon';
import RemoveIcon from 'assets/v2/icons/RemoveIcon';
import RobotIcon from 'assets/v2/icons/RobotIcon';
import SearchIcon from 'assets/v2/icons/SearchIcon';
import SendIcon from 'assets/v2/icons/SendIcon';
import ShareIcon from 'assets/v2/icons/ShareIcon';
import StarIcon from 'assets/v2/icons/StarIcon';
import StarsIcon from 'assets/v2/icons/StarsIcon';
import StatsIcon from 'assets/v2/icons/StatsIcon';
import SupportIcon from 'assets/v2/icons/SupportIcon';
import SwitchIcon from 'assets/v2/icons/SwitchIcon';
import TadaIcon from 'assets/v2/icons/TadaIcon';
import TrashIcon from 'assets/v2/icons/TrashIcon';
import TvIcon from 'assets/v2/icons/TvIcon';
import UploadIcon from 'assets/v2/icons/UploadIcon';
import UserIcon from 'assets/v2/icons/UserIcon';
import VideoIcon from 'assets/v2/icons/VideoIcon';
import Video1Icon from 'assets/v2/icons/Video1Icon';
import Video2Icon from 'assets/v2/icons/Video2Icon';
import Video3Icon from 'assets/v2/icons/Video3Icon';
import VideoOffIcon from 'assets/v2/icons/VideoOffIcon';
import ViewsIcon from 'assets/v2/icons/ViewsIcon';
import WandIcon from 'assets/v2/icons/WandIcon';
import WarningIcon from 'assets/v2/icons/WarningIcon';
import WebsiteIcon from 'assets/v2/icons/WebsiteIcon';

// social icons
import AmazonMusicFlatIcon from 'assets/v2/icons/iconFlat/AmazonMusicFlatIcon';
import AmazonFlatIcon from 'assets/v2/icons/iconFlat/AmazonFlatIcon';
import AppleFlatIcon from 'assets/v2/icons/iconFlat/AppleFlatIcon';
import AudiomackFlatIcon from 'assets/v2/icons/iconFlat/AudiomackFlatIcon';
import DeezerFlatIcon from 'assets/v2/icons/iconFlat/DeezerFlatIcon';
import FacebookFlatIcon from 'assets/v2/icons/iconFlat/FacebookFlatIcon';
import GoogleFlatIcon from 'assets/v2/icons/iconFlat/GoogleFlatIcon';
import InstagramFlatIcon from 'assets/v2/icons/iconFlat/InstagramFlatIcon';
import LinkedInFlatIcon from 'assets/v2/icons/iconFlat/LinkedInFlatIcon';
import ShazamFlatIcon from 'assets/v2/icons/iconFlat/ShazamFlatIcon';
import SoundCloudFlatIcon from 'assets/v2/icons/iconFlat/SoundCloudFlatIcon';
import SpotifyFlatIcon from 'assets/v2/icons/iconFlat/SpotifyFlatIcon';
import TiktokFlatIcon from 'assets/v2/icons/iconFlat/TiktokFlatIcon';
import XFlatIcon from 'assets/v2/icons/iconFlat/XFlatIcon';
import YandexFlatIcon from 'assets/v2/icons/iconFlat/YandexFlatIcon';
import YoutubeFlatIcon from 'assets/v2/icons/iconFlat/YoutubeFlatIcon';

// streaming platforms
import AnghamiPlatformIcon from 'assets/v2/icons/iconPlatform/AnghamiPlatformIcon';
import AmazonMusicPlatformIcon from 'assets/v2/icons/iconPlatform/AmazonMusicPlatformIcon';
import AppleMusicPlatformIcon from 'assets/v2/icons/iconPlatform/AppleMusicPlatformIcon';
import AudiomackPlatformIcon from 'assets/v2/icons/iconPlatform/AudiomackPlatformIcon';
import BandcampPlatformIcon from "assets/v2/icons/iconPlatform/BandcampPlatformIcon";
import BeatPortPlatformIcon from "assets/v2/icons/iconPlatform/BeatPortPlatformIcon";
import BoomplayPlatformIcon from "assets/v2/icons/iconPlatform/BoomplayPlatformIcon";
import DeezerPlatformIcon from 'assets/v2/icons/iconPlatform/DeezerPlatformIcon';
import EvenPlatformIcon from 'assets/v2/icons/iconPlatform/EvenPlatformIcon';
import GooglePlayPlatformIcon from 'assets/v2/icons/iconPlatform/GooglePlayPlatformIcon';
import ITunesStorePlatformIcon from 'assets/v2/icons/iconPlatform/ITunesStorePlatformIcon';
import LinkedInPlatformIcon from 'assets/v2/icons/iconPlatform/LinkedInPlatformIcon';
import SoundcloudPlatformIcon from 'assets/v2/icons/iconPlatform/SoundcloudPlatformIcon';
import SpotifyPlatformIcon from 'assets/v2/icons/iconPlatform/SpotifyPlatformIcon';
import TidalPlatformIcon from 'assets/v2/icons/iconPlatform/TidalPlatformIcon';
import TiktokPlatformIcon from 'assets/v2/icons/iconPlatform/TiktokPlatformIcon';
import YandexPlatformIcon from 'assets/v2/icons/iconPlatform/YandexPlatformIcon';
import YoutubePlatformIcon from 'assets/v2/icons/iconPlatform/YoutubePlatformIcon';

import animationAI from 'assets/animationAI.png';
import noImageAvailable from 'assets/images/no-image-available.svg';
import sLogo from 'assets/images/symphony-s-logo.png';

import increaseMusicStreams from 'assets/images/campaigns/musicstreams.png';
import preSave from 'assets/images/campaigns/presave.png';
import increaseVideoViews from 'assets/images/campaigns/videoviews-old.png';
import growInstagramEngagement from 'assets/images/campaigns/boost_ig.png';
import instagramProfileVisits from 'assets/images/campaigns/ig_profile_visits.png';
import growPlaylistFollowers from 'assets/images/campaigns/playlistfollowers.png';
import increaseLinkClicks from 'assets/images/campaigns/linkclicks.png';
import getPlaylisted from 'assets/images/campaigns/playlisting.png';
import musicSite from 'assets/images/websiteThemes/music-site.svg';
import dataCollectorSite from 'assets/images/websiteThemes/data-collector-site.svg';
import presaveSite from 'assets/images/websiteThemes/presave-site.svg';
import tourSite from 'assets/images/websiteThemes/tour.svg';
import tiktokViews from 'assets/images/campaigns/tiktok-views.png';
import tiktokVisits from 'assets/images/campaigns/tiktok-visits.png';

import boostInstagramEngagementV2 from 'assets/v2/images/campaignV2/boostInstagramEngagementV2.svg';
import getPlaylistedV2 from 'assets/v2/images/campaignV2/getPlaylistedV2.svg';
import growPlaylistFollowersV2 from 'assets/v2/images/campaignV2/growPlaylistFollowersV2.svg';
import increaseLinkClicksV2 from 'assets/v2/images/campaignV2/increaseLinkClicksV2.svg';
import increaseMusicStreamsV2 from 'assets/v2/images/campaignV2/increaseMusicStreamsV2.svg';
import increaseVideoViewsV2 from 'assets/v2/images/campaignV2/increaseVideoViewsV2.svg';
import metaEmailSignupsV2 from 'assets/v2/images/campaignV2/metaEmailSignupsV2.svg';
import metaIgSoundV2 from 'assets/v2/images/campaignV2/metaIgSoundV2.svg';
import metaPresavesV2 from 'assets/v2/images/campaignV2/metaPresavesV2.svg';
import metaTicketSalesV2 from 'assets/v2/images/campaignV2/metaTicketSalesV2.svg';
import tiktokEngagementV2 from 'assets/v2/images/campaignV2/tiktokEngagementV2.svg';
import tiktokExternalTrafficV2 from 'assets/v2/images/campaignV2/tiktokExternalTrafficV2.svg';
import tiktokMusicStreamsV2 from 'assets/v2/images/campaignV2/tiktokMusicStreamsV2.svg';
import tiktokSoundV2 from 'assets/v2/images/campaignV2/tiktokSoundV2.svg';
import youtubeEngagementV2 from 'assets/v2/images/campaignV2/youtubeEngagementV2.svg';

import deezer from 'assets/images/platforms/deezer.svg';
import spotify from 'assets/images/platforms/spotify.svg';
import appleMusic from 'assets/images/platforms/apple.svg';
import tidal from 'assets/images/platforms/tidal.svg';
import youtube from 'assets/images/platforms/youtube.svg';
import amazonStore from 'assets/images/music-player.svg';
import amazonMusic from 'assets/images/platforms/amazon-music.svg';
import instagram from 'assets/images/platforms/instagram.svg';
import tiktok from 'assets/images/platforms/tiktok.svg';
import facebook from 'assets/images/platforms/facebook.svg';
import soundcloud from 'assets/images/platforms/soundcloud.svg';
import twitter from 'assets/images/twitter.svg';
import audiomack from 'assets/images/platforms/audiomack.svg';
import fans from 'assets/images/platforms/fans.svg';
import foreverSaves from 'assets/images/platforms/forever-saves.svg';
import facebookRounded from 'assets/images/facebook-rounded-icon.svg';
import instagramBw from 'assets/images/instagram-bw.svg';
import instagramBordered from 'assets/images/instagram-bordered-icon.svg';
import maestroBadgeImage from 'assets/images/maestro/maestro-logo.svg';
import anghami from 'assets/images/platforms/anghami.svg';

// NOTE: V2 ICONS COLORED
import amazonMusicColor from 'assets/v2/icons/iconColor/amazonMusicColor.svg';
import appleMusicColor from 'assets/v2/icons/iconColor/appleMusicColor.svg';
import audiomackColor from 'assets/v2/icons/iconColor/audiomackColor.svg';
import deezerColor from 'assets/v2/icons/iconColor/deezerColor.svg';
import facebookColor from 'assets/v2/icons/iconColor/facebookColor.svg';
import googleColor from 'assets/v2/icons/iconColor/googleColor.svg';
import instagramColor from 'assets/v2/icons/iconColor/instagramColor.svg';
import linkedinColor from 'assets/v2/icons/iconColor/linkedinColor.svg';
import shazamColor from 'assets/v2/icons/iconColor/shazamColor.svg';
import soundcloudColor from 'assets/v2/icons/iconColor/soundcloudColor.svg';
import spotifyColor from 'assets/v2/icons/iconColor/spotifyColor.svg';
import tiktokColor from 'assets/v2/icons/iconColor/tiktokColor.svg';
import xColor from 'assets/v2/icons/iconColor/xColor.svg';
import yandexColor from 'assets/v2/icons/iconColor/yandexColor.svg';
import youtubeColor from 'assets/v2/icons/iconColor/youtubeColor.svg';

import Colors from "modules/Colors";
import Loader from "./Loader";

export const ICON_MAP: Record<string, React.ComponentType<React.SVGProps<SVGSVGElement> & {
    size?: number,
    color?: string,
    isCircle?: boolean,
    onClick?: () => void
}> | React.ComponentType<any>> = {
    // NOTE: BASIC ICONS
    addCircle: AddCircleIcon,
    analytics: AnalyticsIcon,
    arrowLeft: ArrowLeftIcon,
    arrowRight: ArrowRightIcon,
    arrowUp: ArrowUpIcon,
    arrowDown: ArrowDownIcon,
    arrowUpRight: ArrowUpRightIcon,
    audiences: AudiencesIcon,
    billing: BillingIcon,
    book: BookIcon,
    boost: BoostIcon,
    bulletList: BulletListIcon,
    calendar: CalendarIcon,
    chart: ChartIcon,
    check: CheckIcon,
    chevronLeft: ChevronLeftIcon,
    chevronRight: ChevronRightIcon,
    chevronUp: ChevronUpIcon,
    chevronDown: ChevronDownIcon,
    click: ClickIcon,
    clock: ClockIcon,
    close: CloseIcon,
    closeCircle: CloseCircleIcon,
    collapseDrawer: CollapseDrawerIcon,
    comments: CommentsIcon,
    computer: ComputerIcon,
    contextualMenu: ContextualMenuIcon,
    copy: CopyIcon,
    crown: CrownIcon,
    dashboard: DashboardIcon,
    dollarSign: DollarSignIcon,
    download: DownloadIcon,
    downloadCloud: DownloadCloudIcon,
    drag: DragIcon,
    duplicate: DuplicateIcon,
    edit: EditIcon,
    expand: ExpandIcon,
    expandDrawer: ExpandDrawerIcon,
    externalLink: ExternalLinkIcon,
    facebookPixel: FacebookPixelIcon,
    file: FileIcon,
    gear: GearIcon,
    gem: GemIcon,
    gift: GiftIcon,
    globe: GlobeIcon,
    headphones: HeadphonesIcon,
    heart: HeartIcon,
    heartRound: HeartRoundIcon,
    home: HomeIcon,
    image: ImageIcon,
    info: InfoIcon,
    learn: LearnIcon,
    leave: LeaveIcon,
    lightening: LighteningIcon,
    like: LikeIcon,
    limit: LimitIcon,
    link: LinkIcon,
    link2: Link2Icon,
    loading: LoadingIcon,
    mail: MailIcon,
    mailAtSymbol: MailAtSymbolIcon,
    mapPin: MapPinIcon,
    marketing: MarketingIcon,
    menu: MenuIcon,
    message: MessageIcon,
    mobile: MobileIcon,
    money: MoneyIcon,
    music: MusicIcon,
    pause: PauseIcon,
    personCheck: PersonCheckIcon,
    pieChart: PieChartIcon,
    play: PlayIcon,
    plus: PlusIcon,
    qrcode: QrcodeIcon,
    questionMark: QuestionMarkIcon,
    reload: ReloadIcon,
    remove: RemoveIcon,
    robot: RobotIcon,
    search: SearchIcon,
    send: SendIcon,
    share: ShareIcon,
    star: StarIcon,
    stars: StarsIcon,
    stats: StatsIcon,
    support: SupportIcon,
    switch: SwitchIcon,
    tada: TadaIcon,
    trash: TrashIcon,
    tv: TvIcon,
    upload: UploadIcon,
    user: UserIcon,
    video: VideoIcon,
    video1: Video1Icon,
    video2: Video2Icon,
    video3: Video3Icon,
    videoOff: VideoOffIcon,
    views: ViewsIcon,
    wand: WandIcon,
    warning: WarningIcon,
    website: WebsiteIcon,

    // NOTE: SOCIAL ICONS
    amazonMusicFlat: AmazonMusicFlatIcon,
    amazonFlat: AmazonFlatIcon,
    appleFlat: AppleFlatIcon,
    audiomackFlat: AudiomackFlatIcon,
    deezerFlat: DeezerFlatIcon,
    facebookFlat: FacebookFlatIcon,
    googleFlat: GoogleFlatIcon,
    instagramFlat: InstagramFlatIcon,
    linkedinFlat: LinkedInFlatIcon,
    shazamFlat: ShazamFlatIcon,
    soundCloudFlat: SoundCloudFlatIcon,
    spotifyFlat: SpotifyFlatIcon,
    tiktokFlat: TiktokFlatIcon,
    xFlat: XFlatIcon,
    yandexFlat: YandexFlatIcon,
    youtubeFlat: YoutubeFlatIcon,

    // NOTE: STREAMING PLATFORMS
    anghamiPlatform: AnghamiPlatformIcon,
    amazonMusicPlatform: AmazonMusicPlatformIcon,
    appleMusicPlatform: AppleMusicPlatformIcon,
    audiomackPlatform: AudiomackPlatformIcon,
    bandcampPlatform: BandcampPlatformIcon,
    beatportPlatform: BeatPortPlatformIcon,
    boomplayPlatform: BoomplayPlatformIcon,
    deezerPlatform: DeezerPlatformIcon,
    evenPlatform: EvenPlatformIcon,
    googlePlayPlatform: GooglePlayPlatformIcon,
    itunesStorePlatform: ITunesStorePlatformIcon,
    linkedinPlatform: LinkedInPlatformIcon,
    soundcloudPlatform: SoundcloudPlatformIcon,
    spotifyPlatform: SpotifyPlatformIcon,
    tidalPlatform: TidalPlatformIcon,
    tiktokPlatform: TiktokPlatformIcon,
    yandexPlatform: YandexPlatformIcon,
    youtubePlatform: YoutubePlatformIcon,
}

export const IMAGE_MAP: Record<string, string> = {
    // NOTE: BASIC ICONS
    animationAI,
    sLogo,
    noImageAvailable,

    // NOTE: CAMPAIGN ICONS
    increaseMusicStreams,
    preSave,
    increaseVideoViews,
    growInstagramEngagement,
    instagramProfileVisits,
    growPlaylistFollowers,
    increaseLinkClicks,
    getPlaylisted,

    // NOTE: V2 CAMPAIGN ICONS
    boostInstagramEngagementV2,
    getPlaylistedV2,
    growPlaylistFollowersV2,
    increaseLinkClicksV2,
    increaseMusicStreamsV2,
    increaseVideoViewsV2,
    metaEmailSignupsV2,
    metaIgSoundV2,
    metaPresavesV2,
    metaTicketSalesV2,
    tiktokEngagementV2,
    tiktokExternalTrafficV2,
    tiktokMusicStreamsV2,
    tiktokSoundV2,
    youtubeEngagementV2,

    // NOTE: WEBSITE THEME ICONS
    musicSite,
    dataCollectorSite,
    presaveSite,
    tourSite,

    // NOTE: TIKTOK ICONS
    tiktokViews,
    tiktokVisits,

    // NOTE: SOCIAL MEDIA PLATFORM ICONS
    deezer,
    spotify,
    tidal,
    youtube,
    appleMusic,
    amazonStore,
    amazonMusic,
    instagram,
    tiktok,
    facebook,
    soundcloud,
    twitter,
    audiomack,
    fans,
    foreverSaves,
    facebookRounded,
    instagramBw,
    instagramBordered,
    maestroBadgeImage,
    anghami,

    // NOTE: V2 ICONS COLORED
    amazonMusicColor,
    appleMusicColor,
    audiomackColor,
    deezerColor,
    facebookColor,
    googleColor,
    instagramColor,
    linkedinColor,
    shazamColor,
    soundcloudColor,
    spotifyColor,
    tiktokColor,
    xColor,
    yandexColor,
    youtubeColor,

    none: 'none',
}

interface IconProps {
    className: string;
    style?: CSSProperties;
    icon: keyof typeof IMAGE_MAP | keyof typeof ICON_MAP | string;
    iconType?: 'default' | 'custom'
    size?: number;
    onClick?: () => void;
    color?: string
    isCircle?: boolean
    disabled?: boolean
    isLoading?: boolean
}

const Icon = ({
    className,
    icon = 'none',
    iconType = 'default',
    size,
    onClick,
    style,
    color = Colors.purple,
    isCircle = false,
    disabled = false,
    isLoading = false
}: IconProps) => {
    const getIconSizeCss = () => {
        if (isCircle) {
            return {
                width: size ?? 34,
                // height: size ?? 34,
            }
        }
        return {
            width: size ?? 24,
            // height: size ?? 24,
        }
    }

    if (icon === 'none') {
        return null;
    }

    if (isLoading) {
        return (
            <Loader
                className="iconElement_isLoading_loader"
                style={style}
                size={size ?? 24}
            />
        )
    }

    let iconElement: React.ReactNode = null;

    if (ICON_MAP[icon as keyof typeof ICON_MAP]) {
        const IconComponent = ICON_MAP[icon as keyof typeof ICON_MAP];
        iconElement = (
            <IconComponent
                className={className}
                style={styx(
                    { flexShrink: 0 },
                    isCircle ? { width: '100%' } : undefined,
                    !isCircle && onClick && !disabled && { cursor: 'pointer' },
                    !isCircle && style,
                )}
                color={Colors[color as keyof typeof Colors] ?? color}
                size={size}
                onClick={isCircle ? undefined : onClick && !disabled ? () => onClick() : undefined}
            />
        );
    }

    let iconPath: string;
    if (iconType === 'custom') {
        iconPath = icon;
    } else {
        iconPath = IMAGE_MAP[icon as keyof typeof IMAGE_MAP];
    }

    const imageElement = (
        <img
            className={clsx('iconElement', className, `${icon}-IconName`)}
            style={styx(
                sty.iconElement,
                isCircle ? { width: '100%' } : getIconSizeCss(),
                onClick && !disabled && { cursor: 'pointer' },
                iconType === 'custom' && {
                    borderRadius: 8,
                    objectFit: 'cover',
                    overflow: 'hidden',
                },
                !isCircle && style
            )}
            src={iconPath}
            onClick={isCircle ? undefined : onClick && !disabled ? () => onClick() : undefined}
            alt={icon}
        />
    )

    if (isCircle) {
        return (
            <div
                className="iconElement_isCircle"
                style={styx(
                    getIconSizeCss(),
                    { height: size ?? 34 },
                    onClick && { cursor: 'pointer' },
                    sty.circleContainer,
                    isCircle && style
                )}
                onClick={onClick && !disabled ? () => onClick() : undefined}
            >
                {iconElement ?? imageElement}
            </div>
        )
    }

    return iconElement ?? imageElement;
}

const sty: Record<string, CSSProperties> = {
    iconElement: {
        display: 'flex',
        flexShrink: 0,
    },
    circleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        borderRadius: 1000,
        backgroundColor: Colors.purpleLightest,
        padding: 8,
    }
}

export default Icon

// NOTE: → ← ↑ ↓ ›